import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { cart, removeItemCardDto, store } from '../../utils/models'

const initialState: cart = {
  stores: [],
  totalItem: 0
}

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<store>) => {
      const { id, items } = action.payload;

      const storeIndex = state.stores.findIndex(s => s.id === id);

      if (storeIndex !== -1) {
        const store = state.stores[storeIndex];

        const updatedItems = [...store.items];

        items.forEach(newItem => {
          const itemIndex = updatedItems.findIndex(i => i.productId === newItem.productId);
          if (itemIndex !== -1) {
            const updatedItem = {
              ...updatedItems[itemIndex],
              quantity: updatedItems[itemIndex].quantity + newItem.quantity
            };
            updatedItems[itemIndex] = updatedItem;
          } else {
            updatedItems.push({ ...newItem });
          }
        });

        state.stores[storeIndex] = {
          ...store,
          items: updatedItems
        };

      } else {
        state.stores.push({
          ...action.payload,
          items: action.payload.items.map(i => ({ ...i }))
        });
      }
      state.totalItem = state.stores.reduce((sum, store) => {
        return sum + store.items.reduce((s, item) => s + item.quantity, 0);
      }, 0);
    },
    removeFromCart: (state, action: PayloadAction<removeItemCardDto>) => {
      const { storeId, productId } = action.payload;
      const storeIndex = state.stores.findIndex(store => store.id === storeId);
      if (storeIndex >= 0) {
        const filteredItems = state.stores[storeIndex].items.filter(item => item.productId !== productId);
        state.stores[storeIndex] = {
          ...state.stores[storeIndex],
          items: filteredItems,
        };

        if (filteredItems.length === 0) {
          state.stores.splice(storeIndex, 1);
        }
      }
      let total = 0;
      state.stores.forEach(store => {
        store.items.forEach(item => {
          total += item.quantity;
        });
      });
      state.totalItem = total;
    },
    updateQuantity: (
      state,
      action: PayloadAction<{ storeId: string; productId: string; change: number }>
    ) => {
      const { storeId, productId, change } = action.payload;
      const store = state.stores.find((s) => s.id === storeId);
      if (!store) return;

      const item = store.items.find((i) => i.productId === productId);
      if (!item) return;

      item.quantity += change;
      if (item.quantity < 1) {
        item.quantity = 1;
      }
      state.totalItem = state.stores.reduce(
        (sum, s) => sum + s.items.reduce((s2, i) => s2 + i.quantity, 0),
        0
      );
    },
    setQuantity: (
      state,
      action: PayloadAction<{ storeId: string; productId: string; quantity: number }>
    ) => {
      const { storeId, productId, quantity } = action.payload;
      const store = state.stores.find((s) => s.id === storeId);
      if (!store) return;

      const item = store.items.find((i) => i.productId === productId);
      if (!item) return;

      item.quantity = quantity < 1 ? 1 : quantity;
      state.totalItem = state.stores.reduce(
        (sum, s) => sum + s.items.reduce((s2, i) => s2 + i.quantity, 0),
        0
      );
    },
    resetCart: (state) => {
      state.stores = []
    }
  },
})

export const { addToCart, removeFromCart, resetCart, updateQuantity, setQuantity } = cartSlice.actions
export default cartSlice.reducer